<template>
  <div id="layoutAuthentication" class="h-100">
    <div id="layoutAuthentication_content">
      <main>
        <div class="container mt-5">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 col-sm-11">
              <div class="card border-0 shadow-lg mt-5">
                <div class="card-body py-5 px-5 text-center">
                  <img
                    src="/static/img/logo.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <hr class="m-0" />
                <div class="card-body p-md-3">
                  <form v-on:submit.prevent="Validar" autocomplete="off">
                    <div class="form-group">
                      <input
                        :disabled="cargando"
                        required
                        v-model="clave"
                        class="form-control text-center form-control-solid"
                        type="text"
                        placeholder="Ingresa la clave del exámen"
                      />
                    </div>
                    <button
                      class="btn btn-block btn-innovation"
                      :disabled="cargando"
                      type="submit"
                    >
                      <span
                        v-if="cargando"
                        class="spinner-border spinner-border-sm mr-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="cargando">
                        Validando..
                      </span>
                      <span v-else>Validar</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div id="layoutAuthentication_footer">
      <footer class="footer mt-auto footer-dark">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 small">
              Copyright &copy; PSICOFAST 2021
            </div>
            <div class="col-md-6 text-md-right small">
              <a
                :disabled="cargando"
                target="_blank"
                href="https://psicofast.com"
              >
                Política de Privacidad
              </a>
              &middot;
              <a
                :disabled="cargando"
                target="_blank"
                href="https://psicofast.com"
              >
                Términos y condiciones
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { functions, api } from "@/firebase.js";
export default {
  data() {
    return {
      cargando: true,
      clave_cliente: null,
      cliente: null,
      clave: ""
    };
  },
  methods: {
    Validar() {
      var that = this;
      that.cargando = true;
      console.log(that.cliente);
      api("validarTest")({
        clave: that.clave,
        cliente: that.cliente
      })
        .then(response => {
          if (response.data.id != null) {
            let params = {
              clave_test: that.clave,
              clave_cliente: that.clave_cliente,
              cliente: that.cliente,
              test: response.data
            };

            if (this.$route.params.clave_empleado != undefined) {
              params.clave_empleado = this.$route.params.clave_empleado;
            } else if (this.$route.query.empleado != undefined) {
              params.clave_empleado = this.$route.query.empleado;
            }

            that.$router.push({
              name: "Empleado",
              params: params
            });
          } else if (response.data.termino) {
            that.cargando = false;
            swal("El exámen ya terminó", "", "warning");
          } else if (response.data.empezo) {
            that.cargando = false;
            swal("Examen aún no empieza", "", "warning");
          } else {
            that.cargando = false;
            swal("No encontré el exámen", "", "warning");
          }
        })
        .catch(error => {
          that.cargando = false;
          swal("Problemas para validar la información", "", "error");
        });
    },
    ConsultarCliente(clave) {
      var that = this;
      that.clave_cliente = clave;
      that.cargando = true;
      api("validarCliente")({
        clave: clave
      })
        .then(response => {
          if (response.data.id != null) {
            console.log(response.data);
            that.cliente = response.data;
            if (that.$route.params.clave_test != undefined) {
              that.clave = that.$route.params.clave_test;
              that.Validar();
            } else if (that.$route.query.examen != undefined) {
              that.clave = that.$route.query.examen;
              that.Validar();
            } else {
              that.cargando = false;
            }
          } else {
            that.cargando = false;
            swal("No encontré el cliente", "", "warning");
          }
        })
        .catch(error => {
          that.cargando = false;
          swal("Problemas para validar la información", "", "error");
        });
    },
    EjecutarRuta(route_name) {
      this.$router.push({ name: route_name });
    },
    Nada() {}
  },
  computed: {
    ...mapState(["menu"])
  },
  created() {
    $("body").addClass("bg-innovation");
    if (this.$route.params.clave_cliente != undefined) {
      this.ConsultarCliente(this.$route.params.clave_cliente);
    } else if (this.$route.query.empresa != undefined) {
      this.ConsultarCliente(this.$route.query.empresa);
    } else {
      this.cargando = false;
    }
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AppLogin/Test/Test.vue